import { useState, useCallback, useEffect } from "react";
import "./App.css";
import { getUser, loadCurrentUser, User, logout } from "./utils/auth";
import Layout from "./components/Layout";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState<User | null>(getUser());

  useEffect(() => {
    void loadCurrentUser().then(setUser);
  }, []);

  const handleLogin = useCallback(() => {
    setUser(getUser());
  }, []);

  const handleLogout = useCallback(() => {
    logout();
    setUser(null);
  }, []);

  return (
    <div className="app-container">
      <Layout
        user={user}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        onLogout={handleLogout}
        onLogin={handleLogin}
      />
    </div>
  );
}

export default App;
